/**
 * Derive up-to-2-letter initials from a display name (comments avatars, Steg
 * F6). Mirrors `TopBar`'s `initials()` logic but works off a plain
 * `string | null` (a comment's `authorDisplayName`, not a full `MeResponse`) —
 * kept as a small standalone helper so callers never derive display strings
 * from a raw subject id.
 */
const PLACEHOLDER_INITIALS = "?";

export function initialsFromName(name: string | null | undefined): string {
  const source = name?.trim();
  if (!source) return PLACEHOLDER_INITIALS;
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  const letters = (parts[0]?.[0] ?? "") + (parts[1]?.[0] ?? "");
  return (letters || source.slice(0, 2)).toUpperCase();
}
